<template>
  <section class="section">
    <h2 class="section-title">核心产品与服务</h2>
    <div class="product-list">
      <div class="product-item" v-for="item in products" :key="item.title">
        <div class="product-title">{{ item.title }}</div>
        <div class="product-desc">{{ item.desc }}</div>
      </div>
    </div>
  </section>
</template>

<script setup>
const products = [
  {
    title: 'MES 系统',
    desc: '制造执行系统，助力生产流程可视化、标准化与实时监控，实现生产精细化管理。'
  },
  {
    title: 'ERP 系统',
    desc: '覆盖财务、采购、库存、销售、人力等模块，提升企业运营效率，实现资源统一管理。'
  },
  {
    title: 'IOT 平台',
    desc: '面向工业设备物联网应用，实现设备接入、远程监控、数据采集与分析。'
  },
  {
    title: 'APP 开发',
    desc: '为企业提供定制化移动应用开发服务，覆盖 iOS、Android 等多平台。'
  },
  {
    title: 'EAP 系统',
    desc: '实现生产排产和调度管理，优化资源配置，提升生产计划的准确性和响应速度。'
  },
  {
    title: '非标上位机开发',
    desc: '针对工业非标设备，开发定制化上位机软件，实现设备控制、数据采集与远程运维，支持对接各类硬件设备如PLC、传感器、执行器，及运动控制和视觉识别系统。'
  },
  {
    title: '互联网系统',
    desc: '提供高性能的互联网系统解决方案，支持大规模访问与高并发处理，满足业务需求。'
  },
  {
    title: '电商系统',
    desc: '构建完善的电商平台，支持商品管理、订单处理、支付结算及客户管理。'
  },
  {
    title: '人工智能系统开发',
    desc: '基于人工智能技术，提供智能分析、机器学习和图像识别等系统开发服务。'
  }
]
</script>

<style scoped>
.section {
  width: 1200px;
  margin-left: 80px; /* 根据页面布局调整 */
  padding: 2em 1em;
  box-sizing: border-box;
  text-align: left;
}

.section-title {
  font-size: 1.8em;
  font-weight: bold;
  margin-bottom: 1.5em;
  color: #0a74da;
}

.product-list {
  display: flex;
  flex-direction: column;
  gap: 1.5em;
}

.product-item {
  background: #f9f9f9;
  padding: 1.2em 1.5em;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.product-title {
  font-size: 1.1em;
  font-weight: bold;
  color: #007acc;
  margin-bottom: 0.5em;
}

.product-desc {
  font-size: 0.95em;
  color: #333;
  line-height: 1.6;
}
</style>
